import { mapState } from 'vuex'
import { NAMESPACE } from '../store'

export default {
  name: 'BoardMixin',
  props: {
    orgRef: String,
    boardRef: { type: String, required: true },
    nestedEntity: { type: Boolean, default: false }
  },
  data: () => ({
    boardLink: 'board',
    boardCardLink: 'boardCard',
    searchFields: [{ label: 'display', type: 'text' }]
  }),
  computed: {
    ...mapState(NAMESPACE, ['displayType']),
    computedBoardLink() {
      return this.displayType ? `${this.displayType}${this.boardLink}` : this.boardLink
    },
    computedCardLink() {
      return this.nestedEntity && this.displayType ? `${this.displayType}${this.boardCardLink}` : this.boardCardLink
    }
  },
  methods: {
    getBoardItemRoute(entity) {
      return {
        name: this.computedCardLink,
        params: {
          ...this.$router.params,
          boardLink: this.computedBoardLink,
          entityId: entity.id
        }
      }
    }
  }
}
